import { useTranslation } from 'next-i18next';

import {
  getStoreOpeningInfo,
  getClosestOpeningDate,
  getOpeningInfoCaption,
} from '@utils/shop';

import { storeBusinessHoursShape } from '@common/types/shops';

import { Indicator, ColoredCaption, Wrapper, Caption } from './Status.styled';

export const Status = ({ businessHours }) => {
  const { t } = useTranslation();
  let closestOpeningDate;

  const { isStoreOpen, closeTime } = getStoreOpeningInfo(businessHours);

  if (!isStoreOpen) {
    closestOpeningDate = getClosestOpeningDate(businessHours);
  }

  const openingInfoCaption = getOpeningInfoCaption(
    t,
    closeTime,
    isStoreOpen,
    closestOpeningDate,
  );

  return (
    <Wrapper data-testid="storeIndicator">
      <Indicator isStoreOpen={isStoreOpen} />
      <ColoredCaption isStoreOpen={isStoreOpen}>
        {isStoreOpen
          ? t('storeStatus.open', 'Jetzt geöffnet')
          : t('storeStatus.closed', 'Jetzt geschlossen')}
      </ColoredCaption>
      <Caption>{openingInfoCaption}</Caption>
    </Wrapper>
  );
};

Status.propTypes = {
  businessHours: storeBusinessHoursShape.isRequired,
};

export default Status;
